module.exports = __webpack_public_path__ + "media/src/assets/fonts/Montserrat-Light-f5e955efb2bef154ac6dd150903f2d45.otf";